export default __webpack_public_path__ + "static/media/content_tab04_2_04.ad3057b1.png";